<template>
    <div id="errorCode">
        <!--服务级错误码参照(error_code)-->
        <div style="background: #fff;padding-bottom: 56px;">
            <div class="ErrorCodeWrap">
                <div class="errorCodeTitle">服务级错误码参照(error_code)：</div>
                <!--列子-->
                <div class="ErrorCodeListWrap">
                    <div class="ErrorCodeList">
                        <span class="name">错误码</span>
                        <span class="explain">说明</span>
                    </div>
                    <div class="ErrorCodeList" v-for="item in 8" :key="item">
                        <span class="name">231300</span>
                        <span class="explain">参数MD5格式错误</span>
                    </div>
                </div>
            </div>
        </div>
        <!--系统级错误码参照-->
        <div style="background: rgba(0, 15, 13, 0.05);padding-bottom: 56px;">
            <div class="ErrorCodeWrap">
                <div class="errorCodeTitle">系统级错误码参照：</div>
                <!--列子-->
                <div class="ErrorCodeListWrap">
                    <div class="ErrorCodeList">
                        <span class="name">错误码</span>
                        <span class="explain">说明</span>
                        <span class="old">旧版本(resultcode)</span>
                    </div>
                    <div class="ErrorCodeList" v-for="item in 14" :key="item">
                        <span class="name">231300</span>
                        <span class="explain">参数MD5格式错误</span>
                        <span class="old">101</span>
                    </div>
                </div>
            </div>
        </div>
        <!--错误码格式说明-->
        <div>
            <div class="ErrorCodeWrap">
                <div class="errorCodeTitle">错误码格式说明（示例：200201）：</div>
                <div class="ErrorCodeListWrap">
                    <div class="ErrorCodeList">
                        <span class="one">2</span>
                        <span class="two">002</span>
                        <span class="three">01</span>
                    </div>
                    <div class="ErrorCodeList">
                        <span class="one">服务级错误（1为系统级错误）</span>
                        <span class="two">服务模块代码(即数据ID）</span>
                        <span class="three">具体错误代码</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "faceErrorCode",
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            scrollFun() {
                this.$animate(document.getElementsByClassName("ErrorCodeWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("ErrorCodeWrap")[1], "fadeInUp");
                this.$animate(document.getElementsByClassName("ErrorCodeWrap")[2], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #errorCode {
        .errorCodeTitle {
            margin-bottom: 30px;
            font-weight: 600;
            font-size: 16px;
            color: #152346;
        }
        .ErrorCodeWrap {
            width: 1200px;
            margin: 0 auto;
            padding-top: 80px;
            .ErrorCodeListWrap {
                .ErrorCodeList {
                    display: flex;
                    align-items: center;
                    padding-bottom: 12px;
                    margin-bottom: 12px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                    &:last-child {
                        border-bottom: none;
                        margin-bottom: 0;
                    }
                    span {
                        font-size: 16px;
                        text-align: left;
                        color: #152346;
                    }
                    .name {
                        min-width: 55px;
                        margin-right: 80px;
                    }
                    .explain {
                        min-width: 715px;
                        margin-right: 77px;
                    }
                    .old {
                        min-width: 160px;
                    }
                    .one {
                        min-width: 215px;
                        margin-right: 38px;
                    }
                    .two {
                        min-width: 181px;
                        margin-right: 38px;
                    }
                }
            }
        }
    }
</style>